import IDService from "@/services/IDService"
import { store } from '@/store'

export default {
    async getMTBConferences() {
        let url = store.getters.getPathVariable("methods_get_mtb_conferences")
        await IDService.getMTBConferences((event) => {
                        this.progress = Math.round((100 * event.loaded) / event.total);
                    }, url
                )
                .then((response) => {

                    var obj_str = JSON.stringify(response.data);
                    var mtb_data = JSON.parse(obj_str);
                    store.dispatch("setMTBConferences",mtb_data)

                    this.isLoading = false;
                })
                .catch((err) => {
                    console.error("error retrieving variant query data");
                    console.log(err);
                    this.message = 'error '+this.patients;
                    this.isLoading = false;
            })
    },
    async getMTBData(mtb_id) {
            let url = store.getters.getPathVariable("methods_get_mtb_data")
            url = url + '?mtb=' + mtb_id

            await IDService.getMTBData((event) => {
                        this.progress = Math.round((100 * event.loaded) / event.total);
                    }, url
                )
                .then((response) => {

                    var obj_str = JSON.stringify(response.data);
                    var mtb_data = JSON.parse(obj_str);
                    store.dispatch("setMTBData",mtb_data)

                    this.isLoading = false;
                })
                .catch((err) => {
                    console.error("error retrieving variant query data");
                    console.log(err);
                    this.message = 'error '+this.patients;
                    this.isLoading = false;
            })
    },
    async getIDs() {
            let url = store.getters.getPathVariable("methods_get_ids")

            await IDService.getIDs((event) => {
                        this.progress = Math.round((100 * event.loaded) / event.total);
                    }, url
                )
                .then((response) => {

                    var obj_str = JSON.stringify(response.data);
                    var id_list = JSON.parse(obj_str);
                    store.dispatch("setIDList",id_list)

                    this.isLoading = false;
                })
                .catch((err) => {
                    console.error("error retrieving variant query data");
                    console.log(err);
                    this.message = 'error '+this.patients;
                    this.isLoading = false;
            })
        },
        async getIDFeatureData(pid) {
            let url = store.getters.getPathVariable("methods_get_id_feature_data")

            await IDService.getIDFeatureData((event) => {
                        this.progress = Math.round((100 * event.loaded) / event.total);
                    }, url, pid
                )
                .then((response) => {
                    var obj_str = JSON.stringify(response.data);
                    var id_data = JSON.parse(obj_str);
                    let id_list = store.getters.idList
                    id_list[pid] = id_data
                    store.dispatch("setIDList",id_list)
                    store.dispatch("setActiveIdData",id_data[pid])

                    this.isLoading = false;
                })
                .catch((err) => {
                    console.error("error retrieving ID feature data");
                    console.log(err);
                    this.isLoading = false;
            })
        },
        async setActiveIdData(pid) {
            let id_data = store.getters.idList
            //alert(pid)
            store.dispatch("setActiveIdData",id_data[pid])
        }

}
